// extracted by mini-css-extract-plugin
module.exports = {"test":"_1n57p-"};